<section *ngIf="baseForm" class="sh-dialog__content">
    <p *ngIf="infoMessage$ | async as infoMessage">
        <sh-html-parser [message]="infoMessage"></sh-html-parser>
    </p>

    <!-- Source selection -->
    <div class="sh-form-group">
        <sh-form-checkbox-list
            [id]="'export-source'"
            [label]="sourceLabel$ | async"
            [control]="baseForm.controls.source"
            [options]="sourceOptions$ | async"
        ></sh-form-checkbox-list>
    </div>

    <!-- Transformation type -->
    <div class="sh-form-group">
        <sh-form-radio-list
            [id]="'export-transformations'"
            [groupName]="'export-transformations-radio-list'"
            [label]="transformationsLabel$ | async"
            [control]="baseForm.controls.transformations"
            [items]="transformationsOptions$ | async"
        ></sh-form-radio-list>
    </div>

    <!-- Export location -->
    <div class="sh-form-group" [class.sh-clear-margin-bottom]="!(exportReasonRequired$ | async)">
        <sh-form-multi-select
            [id]="'export-exportlocation'"
            [placeholderMsg]="exportLocationNoneSelectedLabel$ | async"
            [label]="exportLocationLabel$ | async"
            [control]="baseForm.controls.exportLocations"
            [options]="exportLocationSelectOptions$ | async"
            [noResultsFoundMsg]="'ui.no-results-rights' | translate"
            [searchPlaceholderMsg]="'ui.search' | translate"
            [listCappedMsg]="'ui.capped-results' | translate"
            [limitHeightToViewport]="true"
            [inOverflownContainer]="true"
        ></sh-form-multi-select>
    </div>

    <!-- Export reason -->
    <ng-container *ngIf="exportReasonForm">
        <div
            class="sh-form-group"
            [class.sh-clear-margin-bottom]="!(customReasonAllowed$ | async)"
            [class.sh-visually-hidden]="!(exportReasonRequired$ | async)"
        >
            <sh-form-multi-select
                [id]="'export-reason'"
                [placeholderMsg]="'media.export-dialog.export-reason.choose-export-reason' | translate"
                [label]="'media.export-dialog.export-reason.label' | translate"
                [control]="exportReasonForm.controls.exportReasons"
                [options]="exportReasonSelectOptions$ | async"
                [noResultsFoundMsg]="'ui.no-results' | translate"
                [searchPlaceholderMsg]="'ui.search' | translate"
                [listCappedMsg]="'ui.capped-results' | translate"
                [sortAlphabetically]="true"
                [limitHeightToViewport]="true"
                [inOverflownContainer]="true"
            ></sh-form-multi-select>
        </div>

        <div class="sh-form-group sh-clear-margin-bottom" *ngIf="customReasonAllowed$ | async">
            <sh-form-text-input
                [id]="'export-custom-reason'"
                [label]="'media.export-dialog.custom-reason.label' | translate"
                [control]="exportReasonForm.controls.customReason"
            ></sh-form-text-input>
        </div>
    </ng-container>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button
            type="button"
            class="sh-button sh-action-group__item"
            (click)="confirm()"
            [disabled]="baseForm.invalid || exportReasonForm.invalid || disableDownload"
            [title]="disabledDownloadMsg"
        >
            {{ config.data.ok }}
        </button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ config.data.cancel }}</button>
    </div>
</footer>
